// @flow
import React from "react"
import YoutubeVideo from "components/YoutubeVideo"
import { WhiteWrap } from "componentsStyled/Layout/WhiteWrap"
import { PageTitle } from "componentsStyled/Typography/Titles"
import { StyledContainer as Container, Content } from "./styled"

type Props = {
  title: string,
  videoURL: string,
}

const SectionVideo = ({ title, videoURL }: Props) => (
  <WhiteWrap>
    <Container>
      <PageTitle>
        {title}
      </PageTitle>
      <Content>
        <YoutubeVideo source={videoURL} />
      </Content>
    </Container>
  </WhiteWrap>
)

export default SectionVideo



// WEBPACK FOOTER //
// ./src/components/SectionVideo/index.js